import React from 'react';
import _ from 'lodash';
import { array, bool, string } from 'prop-types';
import Drugs from '../../static/RelatedPopularDrugs';
import { withTranslation } from 'react-i18next';

const RelatedDrugs = ({
  i18n,
  isFromCms = false,
  isWhatIs = false,
  relatedDrugs = [],
  t,
  title = ''
}) => {
  let relatedDrugHeading = !_.isEmpty(relatedDrugs)
    ? 'Related drugs'
    : 'Popular drugs';

  const getRelatedDrugs = lang => {
    let drugs = !_.isEmpty(relatedDrugs) ? relatedDrugs : Drugs.popularDrugs;
    return drugs.map((item, id) => {
      return (
        <li key={id}>
          <a
            href={
              isWhatIs
                ? `/prescription/${item.seoName}/what-is`
                : `${_.withLocale(lang, '/prescription')}/${item.seoName}`
            }
          >
            {isFromCms && !_.isEmpty(relatedDrugs) ? item.name : item.drugName}
          </a>
        </li>
      );
    });
  };
  return (
    <section className="top-drugs">
      <article>
        <h2 className="relatedDrugHeading">
          {title ? title : t(relatedDrugHeading)}
        </h2>
        <ul>{getRelatedDrugs(i18n.language)}</ul>
      </article>
    </section>
  );
};

RelatedDrugs.propTypes = {
  relatedDrugs: array,
  isWhatIs: bool,
  isFromCms: bool,
  title: string
};

export default React.memo(withTranslation()(RelatedDrugs));
